/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,

  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import { useState, useEffect } from "react";
import { finalizaAnteojoArreglo } from "../../services/ProduccionService";
import DatosGestionAtencionCliente from "./DatosGestionAtencionCliente";
import DatosAnteojoArreglo from "./DatosAnteojoArreglo";
import DatosBandejaActual from "./DatosBandejaActual";
import DatosAreaActual from "./DatosAreaActual";
import DatosAccordion from "./DatosAccordion";
import WaitingDialog from "../../utils/WaitingDialog";

const initialFinalizarAnteojoArregloData = {
  observaciones: "",
};
//
// ###########################################################################
//
const FinalizarAnteojoArregloDialog = ({
  idGestionAtencion,
  anteojoArreglo,
  idGcAnteojoArreglo,
  onFinalizarAnteojoArreglo,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [finalizarAnteojoArregloData, setFinalizarAnteojoArregloData] = useState(
    initialFinalizarAnteojoArregloData
  );
  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const [datosAccordionSummaryCargados, setDatosAccordionSummaryCargados] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (accordionExpanded && !datosAccordionSummaryCargados) {
      setDatosAccordionSummaryCargados(true);
    }
  }, [accordionExpanded]);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setFinalizarAnteojoArregloData({
      ...finalizarAnteojoArregloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const getAreaActual = async () => { };
  //
  // ################################################################################
  //
  const getBandejaActual = async () => { };
  //
  // ################################################################################
  //
  const FinalizarAnteojoArreglo = async () => {
    console.log("---");
    console.log("in FinalizarAnteojoArreglo");
    console.log("finalizarAnteojoArregloData");
    console.log(finalizarAnteojoArregloData);
    console.log();

    if (!finalizarAnteojoArregloData.observaciones) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar observaciones para finalizar el Anteojo / Arreglo.",
      });
      setShowMessage(true);
      return;
    }

    let _FinalizarAnteojoArregloObject = {
      anteojo_arreglo: anteojoArreglo,
      id_gc_anteojo_arreglo: idGcAnteojoArreglo,
      observaciones: finalizarAnteojoArregloData.observaciones,
    };
    save(_FinalizarAnteojoArregloObject);
  };
  //
  // ################################################################################
  //
  const save = async (parFinalizaAnteojoArreglo) => {
    setIsDoingSomething(true);
    const response = await finalizaAnteojoArreglo(parFinalizaAnteojoArreglo);
    setIsDoingSomething(false);
    if (response.ok) {
      onFinalizarAnteojoArreglo();
    }
    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Finaliza Anteojo / Arreglo
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Accordion
            sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}
            expanded={accordionExpanded}
            onChange={() => {
              setAccordionExpanded(!accordionExpanded);
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <DatosAccordion idGestionAtencion={idGestionAtencion} />
            </AccordionSummary>
            <AccordionDetails>
              {datosAccordionSummaryCargados && (
                <>
                  {idGestionAtencion && (
                    <DatosGestionAtencionCliente idGestionAtencion={idGestionAtencion} />
                  )}

                  {anteojoArreglo && (
                    <>
                      <DatosAnteojoArreglo
                        anteojoArreglo={anteojoArreglo}
                        idGcAnteojoArreglo={idGcAnteojoArreglo}
                      />

                      <DatosAreaActual
                        anteojoArreglo={anteojoArreglo}
                        idGcAnteojoArreglo={idGcAnteojoArreglo}
                        setAreaActual={getAreaActual}
                      />

                      <DatosBandejaActual
                        anteojoArreglo={anteojoArreglo}
                        idGcAnteojoArreglo={idGcAnteojoArreglo}
                        setBandejaActual={getBandejaActual}
                      />
                    </>
                  )}
                </>
              )}
            </AccordionDetails>
          </Accordion>

          <Box
            sx={{
              border: "2px solid steelblue",
              borderRadius: "5px",
              p: 2,
            }}
          >
            <Grid container spacing={1} sx={{ mb: 1 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  id="observaciones"
                  label="Observaciones"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    style: { textAlign: "left" },
                  }}
                  name="observaciones"
                  value={finalizarAnteojoArregloData.observaciones}
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions>
          <Box sx={{ textAlign: "right", p: 1 }}>
            <Button
              sx={{ mr: 1, backgroundColor: "warning" }}
              variant="contained"
              onClick={() => {
                FinalizarAnteojoArreglo();
              }}
              startIcon={<DoneAllOutlinedIcon />}
            >
              Finalizar
            </Button>
            <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
              Cancelar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default FinalizarAnteojoArregloDialog;
